import { ele } from "cables-shared-client";
import Api from "../../api.js";
import web from "../../index.js";

export default class PagePatchDependencies
{
    constructor(targetElement)
    {
        // (targetEl, projectId)
        const projectId = targetElement.dataset.projectid;
        const loadingIndicator = ele.byId("loading");
        if (loadingIndicator) loadingIndicator.classList.remove("hide");

        const apiUrl = "assets/dependencies/" + projectId;

        Api.get(apiUrl, (result) =>
        {
            ele.byId("num_patches").innerText = "(" + result.data.projects.length + ")";
            if (result.data.projects.length > 0) ele.show(ele.byId("tab_patches"));
            ele.byId("num_ops").innerText = "(" + result.data.ops.length + ")";
            if (result.data.ops.length > 0) ele.show(ele.byId("tab_ops"));

            web.projectPagePatchList(result.data.projects, "patches", "No patches found", result.pagination);

            const morePatchesEle = ele.byId("otherPatchesCount");
            if (morePatchesEle)
            {
                if (result.data.moreCount)
                {
                    const countField = morePatchesEle.querySelector(".count");
                    countField.innerText = result.data.moreCount;
                    ele.show(morePatchesEle);
                }
                else
                {
                    ele.hide(morePatchesEle);
                }
            }

            let html = "";
            const ops = result.data.ops;
            for (const i in ops)
            {
                html += web.getHandleBarHtml("op", ops[i]);
            }

            ele.byId("ops").innerHTML = html;
            if (loadingIndicator) loadingIndicator.classList.add("hide");
        });
    }
}

